module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dKyBE"))).then(() => parcelRequire('cvs7o'));